<form class="profile-form" [formGroup]="editForm" (ngSubmit)="onEdit()">
  <!--  <p class="phone-number" *ngIf="user && user.hasOwnProperty('username')">{{'PHONE_NUMBER' | translate}}: <span class="username">{{user.username}}</span></p>-->

  <label for="phone-number">{{'PHONE_NUMBER' | translate}}</label>
  <input
    id="phone-number"
    type="text"
    class="profile-field"
    disabled
    *ngIf="user && user.hasOwnProperty('username')"
    [value]="user.username" />

  <div class="name-wrapper">
    <div class="first-name-wrapper">
      <label for="first-name">{{ 'FIRST_NAME' | translate }}</label>
      <input id="first-name" type="text" class="profile-field" formControlName="firstName" [placeholder]="'FIRST_NAME' | translate" />
    </div>
    <div class="last-name-wrapper">
      <label for="last-name">{{ 'LAST_NAME' | translate }}</label>
      <input id="last-name" type="text" class="profile-field" formControlName="lastName" [placeholder]="'LAST_NAME' | translate" />
    </div>
  </div>

  <label for="language">{{'LANGUAGE' | translate}}</label>
  <select id="language" formControlName="language">
    <option [ngValue]="null" disabled>{{ 'SELECT_A_LANGUAGE' | translate }}</option>
    <option [ngValue]="language" *ngFor="let language of languages; first as firstElement">{{ language | translate}}</option>
  </select>
  <label for="skip-movement_assignments">{{'MOVEMENT_ASSIGNMENTS' | translate}}</label>
  <select id="skip-movement_assignments" formControlName="movementAssignmentSkipAble">
    <option [ngValue]="true">{{ 'YES' | translate }}</option>
    <option [ngValue]="false">{{ 'NO' | translate }}</option>
  </select>
  <label for="state">{{'ACCOUNT_STATUS' | translate}}</label>
  <select id="state" formControlName="state">
    <option [ngValue]="'active'">{{ 'ACTIVE' | translate }}</option>
    <option [ngValue]="'paused'">{{ 'PAUSED' | translate }}</option>
    <option [ngValue]="'archived'">{{ 'ARCHIVED' | translate }}</option>
  </select>
  <button class="edit-button">{{'SAVE' | translate}}</button>
</form>
